"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SET_CLIENT_CONFLATION_FILTER request.
 */
var SetClientConflationFilterRequest = /** @class */ (function () {
    /**
     * Create a new SetClientConflationFilterRequest instance
     *
     * @param filter    a session filter
     * @param conflate  enable or disable conflation
     */
    function SetClientConflationFilterRequest(filter, conflate) {
        this.filter = filter;
        this.conflate = conflate;
    }
    return SetClientConflationFilterRequest;
}());
exports.SetClientConflationFilterRequest = SetClientConflationFilterRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/set-client-conflation-filter-request.js
// module id = 1212
// module chunks = 1